var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotepadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.125H22.5C23.1213 19.125 23.625 18.6213 23.625 18C23.625 17.3787 23.1213 16.875 22.5 16.875H13.5C12.8787 16.875 12.375 17.3787 12.375 18C12.375 18.6213 12.8787 19.125 13.5 19.125Z",
    fill: "#232360"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 23.625H22.5C23.1213 23.625 23.625 23.1213 23.625 22.5C23.625 21.8787 23.1213 21.375 22.5 21.375H13.5C12.8787 21.375 12.375 21.8787 12.375 22.5C12.375 23.1213 12.8787 23.625 13.5 23.625Z",
    fill: "#232360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28401 5.15901C6.28401 5.15901 6.94302 4.5 7.875 4.5H28.125C28.125 4.5 29.057 4.5 29.716 5.15901C29.716 5.15901 30.375 5.81802 30.375 6.75V28.125C30.375 28.125 30.375 29.989 29.057 31.307C29.057 31.307 27.739 32.625 25.875 32.625H10.125C10.125 32.625 8.26104 32.625 6.94302 31.307C6.94302 31.307 5.625 29.989 5.625 28.125V6.75C5.625 6.75 5.625 5.81802 6.28401 5.15901ZM7.875 6.75V28.125C7.875 28.125 7.875 29.057 8.53401 29.716C8.53401 29.716 9.19302 30.375 10.125 30.375H25.875C25.875 30.375 26.807 30.375 27.466 29.716C27.466 29.716 28.125 29.057 28.125 28.125V6.75H7.875Z",
    fill: "#232360"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 3.375V7.875C10.125 8.49632 10.6287 9 11.25 9C11.8713 9 12.375 8.49632 12.375 7.875V3.375C12.375 2.75368 11.8713 2.25 11.25 2.25C10.6287 2.25 10.125 2.75368 10.125 3.375Z",
    fill: "#232360"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 3.375V7.875C16.875 8.49632 17.3787 9 18 9C18.6213 9 19.125 8.49632 19.125 7.875V3.375C19.125 2.75368 18.6213 2.25 18 2.25C17.3787 2.25 16.875 2.75368 16.875 3.375Z",
    fill: "#232360"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 3.375V7.875C23.625 8.49632 24.1287 9 24.75 9C25.3713 9 25.875 8.49632 25.875 7.875V3.375C25.875 2.75368 25.3713 2.25 24.75 2.25C24.1287 2.25 23.625 2.75368 23.625 3.375Z",
    fill: "#232360"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepadIcon);
export default __webpack_public_path__ + "static/media/notepad-icon.45ad2ebaa0d8b0929f450f5b7838ca1c.svg";
export { ForwardRef as ReactComponent };